// extracted by mini-css-extract-plugin
export default {"btnShop":"BtnShop_btnShop__7meVU","btnShop__text":"BtnShop_btnShop__text__DpP-1","active":"BtnShop_active__0q+83"};